// src/pages/FAQ.js
import React, { useEffect, useRef } from 'react';
import { useContent } from '../context/ContentContext';
import FAQItem from '../components/faq/FAQItem';
import { fadeIn } from '../utils/gsapAnimations';

function FAQ() {
  const pageRef = useRef(null);
  const { content, loading, error } = useContent();

  useEffect(() => {
    fadeIn(pageRef.current, 0.3);
  }, []);

  if (loading) return <div className="text-center py-12 text-primary">Loading...</div>;
  if (error) return <div className="text-center py-12 text-red-500">{error}</div>;

  const faqs = content.faq?.faqs || [];

  return (
    <div ref={pageRef} className="bg-cream py-12">
      <div className="max-w-3xl mx-auto px-4">
        <h1 className="text-3xl font-playfair-display font-semibold text-primary mb-8 text-center">
          {content.faq?.title || 'Frequently Asked Questions'}
        </h1>
        <div className="space-y-2">
          {faqs.map((faq, index) => (
            <FAQItem
              key={index}
              question={faq.question}
              answer={faq.answer}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default FAQ;